import { combineReducers } from 'redux';
import { COPY_TRIGGER, COPY_SUCCESS } from './actions';

export function isCopying(state = false, action) {
  switch (action.type) {
    case COPY_TRIGGER:
      return true;
    case COPY_SUCCESS:
      return false;
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  isCopying,
});

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default rootReducer;
